module.exports = __webpack_public_path__ + "static/obj_3@2x-23fb1d2e664ea7d4b831c678e84a7246.png";